export default __webpack_public_path__ + "MBD_Datenschutz_Stand_11-2025.pdf";